<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative pr-83">
            <b-row class="mb-16">
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Start Date" oneline>{{ Item.started_date ? $options.filters.formatDatebyMoment(Item.started_date, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field label="End Date" oneline>{{ Item.expiry_date ? $options.filters.formatDatebyMoment(Item.expiry_date, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7">
                    <b-row>
                        <b-col md="4">
                            <gofix-text-field label="PTW Type" oneline>{{ Item.type }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field label="Requestor" oneline>{{ Item.created_by_user && Item.created_by_user.name ? Item.created_by_user.name : '' }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field classInner="justify-content-end" label="Status" oneline>{{ Item.status }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Submitted Date" oneline>{{ Item.submitted_at ? $options.filters.formatDatebyMoment(Item.submitted_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Submitted By" oneline>{{ Item.submitted_by && Item.submitted_by.name ? Item.submitted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7">
                    <b-row>
                        <b-col md="4">
                            <gofix-text-field label="Project Name" oneline>{{ Item.project && Item.project.contract_reference_number ? Item.project.contract_reference_number : '' }}</gofix-text-field>
                        </b-col>
                        
                        <b-col md="4">
                            <gofix-text-field label="Project Manage" oneline>{{ Item.project_manager_by && Item.project_manager_by.name ? Item.project_manager_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Completed By" oneline>{{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Completed Date" oneline>{{ Item.completed_by && Item.completed_by.name ? Item.completed_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Assesor" oneline>{{ Item.assesor_by && Item.assesor_by.name ? Item.assesor_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Number of Supervisor" oneline>{{ Item.number_of_supervisor ? Item.number_of_supervisor : 0 }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Number of Workmen" oneline>{{ Item.number_of_workmen ? Item.number_of_workmen : 0 }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Location" oneline>{{ Item.properties && Item.properties.name ? Item.properties.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="12">
                    <gofix-text-field label="Description of Work" oneline>
                        <span v-html="Item.description ? Item.description.replaceAll('\n', '<br>') : ''"></span>
                    </gofix-text-field>
                </b-col>
            </b-row>
            <span v-if="isChangeStatus" style="top: 0 !important; right: 31px !important;" @click="editBacsicInfo" class="editBox position-absolute cursor-pointer">
                <img src="img/iconPencil.png" alt="edit bacsic info" with="18px" height="18">
            </span>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Basic Info" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <b-row class="mb-10">
                    <b-col md="12">
                         <gofix-text-field class="mb-10" label="Project Name" oneline>{{ Item.project_id }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Contractor Company" oneline>{{ Item.supplier }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Location"  oneline>{{ Item.properties && Item.properties.name ? Item.properties.name : '' }}</gofix-text-field>
                    </b-col>
                </b-row>
                <br />
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :disabled="modals.bacsicInfo.options.status.length == 0"
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                    <gofix-form-dropdown 
                        v-if="Item.status == 'New'"
                        label="Submitted By" 
                        vLabel="name" 
                        @search="searchUsers" 
                        :filterable="false" 
                        :reduce="option => option.id"
                        v-model="modals.bacsicInfo.data.submitted_by_id" 
                        :options="modals.bacsicInfo.options.fm_users">
                    </gofix-form-dropdown>
                    <gofix-form-dropdown 
                        v-if="Item.status == 'Submitted'"
                        label="Completed By" 
                        vLabel="name" 
                        @search="searchUsers" 
                        :filterable="false" 
                        :reduce="option => option.id"
                        v-model="modals.bacsicInfo.data.completed_by_id" 
                        :options="modals.bacsicInfo.options.fm_users">
                    </gofix-form-dropdown>
                    <gofix-form-dropdown 
                        v-if="Item.status == 'Completed'"
                        label="Approved By" 
                        vLabel="name" 
                        @search="searchUsers" 
                        :filterable="false" 
                        :reduce="option => option.id"
                        v-model="modals.bacsicInfo.data.approved_by_id" 
                        :options="modals.bacsicInfo.options.fm_users">
                    </gofix-form-dropdown>
                    <b-row v-if="Item.status == 'New'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.submitted_at" label="Submitted Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Submitted Time" v-model="modals.bacsicInfo.data.submitted_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="Item.status == 'Submitted'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.completed_at" label="Completed Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Completed Time" v-model="modals.bacsicInfo.data.completed_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="Item.status == 'Completed'">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.approved_at" label="Approved Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Approved Time" v-model="modals.bacsicInfo.data.approved_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="checkShowPopUpSignature" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    export default {
        name: 'permit-to-work-detail-info',
        data() {
            return {
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            completed_by_id: null,
                            approved_by_id: null,
                            submitted_by_id: null,
                            submitted_at: null,
                            submitted_at_hour: null,
                            approved_at: null,
                            approved_at_hour: null,
                            completed_at: null,
                            completed_at_hour: null,
                        },
                        options: {
                            status: ['Submitted', 'Approved', 'Completed'],
                            fm_users: [],
                            supllier_users: [],
                        }
                    }
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Completed'],
                    'Completed': ['Approved'],                    
                }
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            jobOptionStatus() {
                return this.option_status[this.Item.status];
            },
            isChangeStatus() {
                if(!this.$checkRole(this.$accessModule.permit_to_work, 'update')) return false;
                return this.Item && ((this.Item.related_id == null && this.Item.status == 'New') || (
                    this.Item.related_id != null && (this.Item.status != 'New' && this.Item.status != 'Approved') && (this.Item.planned_date && new Date(this.Item.planned_date).toDateString() === new Date().toDateString())
                ));
            }
        },
        created() {
            
        },
        methods: {
            /*-- Get Data --------*/
            editBacsicInfo() {
                this.loadUser(100);
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    completed_by_id: this.Item.completed_by_id,
                    approved_by_id: this.Item.approved_by_id,
                    submitted_by_id: this.Item.submitted_by_id,
                    submitted_at: this.Item.submitted_at ? new Date(this.Item.submitted_at) : null,
                    submitted_at_hour: this.Item.submitted_at ? moment(new Date(this.Item.submitted_at)).format("HH:mm") : null,
                    approved_at: this.Item.approved_at ? new Date(this.Item.approved_at) : null,
                    approved_at_hour: this.Item.approved_at ? moment(new Date(this.Item.approved_at)).format("HH:mm") : null,
                    completed_at: this.Item.completed_at ? new Date(this.Item.completed_at) : null,
                    completed_at_hour: this.Item.completed_at ? moment(new Date(this.Item.completed_at)).format("HH:mm") : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            loadUser(limit_item, filters = {}) {
                if(this.Item.status == 'New' || this.Item.status == 'Approved') {
                    filters.type_user = 'fm_user';
                } else {
                    filters.type_user = 'supplier_user';
                }
                this.$store
                    .dispatch("v2UserController/searchListUser", {
                        limit: limit_item,
                        page: 1,
                        filters: filters,
                        useDatabaseView: true
                    })
                    .then((response) => {
                        if(filters.type_user == 'fm_user') {
                            this.modals.bacsicInfo.options.fm_users = response.data;
                        } else {
                            this.modals.bacsicInfo.options.supllier_users = response.data;
                        }
                    })
                    .catch((err) => {});
            },
            searchUsers(search, loading) {
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.loadUser(100, {
                        name: search
                    });
                    loading(false);
                }, 500);
            },
            checkShowPopUpSignature() {
                this.updateBasicInfo();
            },
            updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                let params = this.processJob(this.modals.bacsicInfo.data);
                if(params === false) return

                // params = Object.assign(params, {
                //     location              : this.Item.location,
                //     location_id           : this.Item.location_id,
                //     client_contract_id    : this.Item.client_contract_id,
                //     supplier              : this.Item.supplier,
                //     supplier_id           : this.Item.supplier_id,
                //     equipment_id          : this.Item.equipment_id,
                //     equipment_lift_number : this.Item.equipment_lift_number,
                //     checklist_template_id : this.Item.checklist_template_id,
                //     project_id            : this.Item.project_id,
                //     type                  : this.Item.type,
                //     started_date          : this.Item.started_date,
                //     expiry_date           : this.Item.expiry_date,
                // });

                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: this.Item.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "permit_to_work"));
                        // this.is_open_signature = false;
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'Approved') status = 'pm_acknowledged';
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'completed': {
                        status: 'Completed',
                        completed_by_id: data.completed_by_id || null,
                        completed_at: null,
                    },
                    'approved': {
                        status: 'Approved',
                        approved_by_id: data.approved_by_id || null,
                        approved_at: null,
                    },
                    
                };
                

                const obj = defaultStatus[status];

                if(!obj[`${status}_by_id`]) {
                    this.$alertNotification(`Please select ${obj.status} By`, "danger");
                    return false
                }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            }
        }
    }
</script>